import React from 'react'
import cn from 'classnames'

import './CloseButton.less'

type CloseButtonProps = {
  className?: string
  label?: string
} & React.ButtonHTMLAttributes<HTMLButtonElement>

function CloseButton({ className, label = 'Close', ...rest }: CloseButtonProps) {
  return (
    <button type="button" className={cn('close', className)} aria-label={label} {...rest}>
      <span aria-hidden>&times;</span>
    </button>
  )
}

export default CloseButton
